module.exports = __webpack_public_path__ + "img/0e3bb070707d280beb4a78e3e3f65f47.svg";